// EmailSetup.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';        // already holds .steps-list and .thumb rules

export default function EmailSetup() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Email Setup
      </Typography>

     
          <Typography paragraph>
            Complete the form below to personalise each outbound message. To add data from your spreadsheet click on the button chips of the corresponding columns.
          </Typography>
            <img
            src="../../static/docs/columnchipbuttons.jpg"
            alt="Select Excel/CSV file"
            className="step-img"
          />
          <List className="steps-vertical" sx={{marginLeft:"2rem"}}>
                                               <ListItem sx={{marginLeft:"1rem"}}>
              <b>Sender</b> — From Name and From Email (From Email is locked on your current signed in PostSheet account)
            </ListItem>
         <ListItem sx={{marginLeft:"1rem"}}>
              <b>Recipient</b> — To Email and eptional To Name
            </ListItem>
              <ListItem sx={{marginLeft:"1rem"}}>
              <b>Subject</b> — Subject of your email
            </ListItem>
            <ListItem sx={{marginLeft:"1rem"}}>
              <b>BCC</b> — add BCC address to send the email for two addresses at once.
            </ListItem>
            <ListItem sx={{marginLeft:"1rem"}}>
              <b>Attachments</b> — upload files (max&nbsp;10&nbsp;MB each).
            </ListItem>
            <img
            src="../../static/docs/uppernewcampaign.jpg"
            alt="Select Excel/CSV file"
            className="step-img"
          />
           <ListItem sx={{marginLeft:"1rem"}}>
              <b>Body</b> — Write or paste your HTML / plain-text
              content.
            </ListItem>
              <ListItem sx={{marginLeft:"1rem"}}>
              <b>Opt-Out footer</b> — toggle ON to append an
              unsubscribe link and custom message.
            </ListItem>
             
          <ListItem sx={{marginLeft:"1rem"}}>
              <b>AI assist</b> — click&nbsp;<b>Generate Email with AI</b>
              to re-phrase or expand the body (makes best suggestions when some
              draft text is already present).
            </ListItem>
          </List>
                  <img
            src="../../static/docs/CkEditorOptOut.jpg"
            alt="Select Excel/CSV file"
            className="step-img"
          />
          <Typography paragraph sx={{ mt: 2 }}>
            When everything looks good, hit <b>Next</b> to see
            the first few personalised emails before scheduling the send.
          </Typography>
    </Box>
  );
}
